import { ActionType, USE_CURRENT_JOB } from '../actions/serviceInfo'

export interface ServiceInfoState {
	useCurrentJob: boolean
}

const initialState: ServiceInfoState = {
	useCurrentJob: false
}

export function serviceInfoReducer(state: ServiceInfoState = initialState, action: ActionType) {
	switch (action.type) {
		case USE_CURRENT_JOB: {
			return {
				...state,
				useCurrentJob: action.payload.useCurrentJob
			}
		}
		default: {
			return state
		}
	}
}



// WEBPACK FOOTER //
// ./src/reducers/serviceInfo.ts